/**
 * Boutons d'achat des sections sur mesure (fiche pdp-main + bloc offre des pages de vente) :
 * ajoute au panier sans quitter la page puis ouvre le tiroir panier du thème.
 * Garde tels quels les champs du formulaire (quantité et propriétés Rapid Bundle).
 * Sans JavaScript ou si l'ajout échoue, le formulaire repart en envoi classique vers /cart.
 */
import { CartLinesUpdateEvent } from '@shopify/events';
import { morphSection } from '@theme/section-renderer';

const FORMS = 'form.pdp-buy, form.sp-offer__form';
const DRAWER_SECTION = 'cart-drawer-section';

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches(FORMS)) return;
  // Le tiroir n'existe que si le thème est réglé en mode « drawer »
  if (!document.getElementById(`shopify-section-${DRAWER_SECTION}`)) return;

  event.preventDefault();
  const button = form.querySelector('[type="submit"]');
  if (button?.getAttribute('aria-busy') === 'true') return;
  button?.setAttribute('aria-busy', 'true');

  const formData = new FormData(form);
  formData.append('sections', DRAWER_SECTION);
  formData.append('sections_url', window.location.pathname);

  let added = false;
  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      body: formData,
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
    });
    const result = await response.json();
    if (result.status) throw new Error(result.description || result.message || 'Add to cart failed');
    added = true;

    // Remplit d'abord le tiroir (il peut être vide au chargement), puis prévient le thème :
    // le compteur du panier se met à jour et le tiroir s'ouvre (réglage auto_open_cart_drawer).
    const html = result.sections?.[DRAWER_SECTION];
    if (html) await morphSection(DRAWER_SECTION, html, { mode: 'full' });

    const cart = await fetch(`${Theme.routes.cart_url}.js`).then((res) => res.json());
    form.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: String(formData.get('id')), quantity: Number(formData.get('quantity')) || 1 }],
        promise: Promise.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'adv-cart', sections: result.sections, didError: false },
        }),
      })
    );
    document.getElementById('cart-drawer')?.open?.();
  } catch (error) {
    console.warn('[adv-cart]', error);
    // Déjà ajouté : on montre la page panier ; sinon, envoi classique du formulaire
    if (added) window.location.href = Theme.routes.cart_url;
    else form.submit();
  } finally {
    button?.removeAttribute('aria-busy');
  }
});
